import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Anthem Blue Cross California",
  shortName: "Anthem Blue Cross CA",
  slug: "anthem-blue-cross-insurance",
  seoTitle: "Anthem Blue Cross California TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Anthem Blue Cross California? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Anthem Blue Cross CA plan in Coral Springs, FL.",
  seoKeywords:
    "Anthem Blue Cross California TMS coverage, Anthem CA TMS therapy, Anthem Blue Cross CA depression treatment Florida, Anthem California mental health benefits Coral Springs FL, Anthem Blue Cross CA SAINT TMS",
  planType: "health insurance plan (Anthem, Inc. — Elevance Health subsidiary)",
  planRegion: "California",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health and substance use disorder services",
  planSpecificIntro:
    "Anthem Blue Cross California (part of Elevance Health) is an independent licensee of the Blue Cross Blue Shield Association, providing health coverage to members across California. Anthem Blue Cross CA plans typically include behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. Coverage for TMS, accelerated TMS protocols like SAINT, and other advanced depression treatments depends on your individual plan type, network status, and documented prior treatment history.",
  officialResourceUrl: "https://www.anthem.com/ca/",
  officialResourceLabel: "Anthem Blue Cross California official website",
};

export const AnthemBlueCrossInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AnthemBlueCrossInsurance;
